
import { css } from 'lit';
export default css`
:host{
  height:100%;
  display:flex;
  flex-direction:column;
}

.teaser-card{
  --heading-font-weight:var(--fw-light);
  display:flex;
  flex-direction:column;
  gap:1.5rem;
  position:relative;
}

.teaser-card.has-border-x{
  border-top:2px solid var(--purple-medium-neutral);
  padding:2rem 0;
}

.teaser-card.has-border-bottom{
  border-bottom:2px solid var(--purple-medium-neutral);
  padding:2rem 0;
}

.image{
  overflow:hidden;
  border-bottom-right-radius:32px;
  display:flex;
  flex-grow:1;
}

.content{
  display:grid;
  gap:0.5rem;
}

.prefooter .content{
    gap:0px;
  }

.eyebrow{
  font-family:var(--ff-body);
  font-size:14px;
  font-weight:400;
  line-height:19px;
  letter-spacing:0em;
  text-align:left;
  color:var(--neutral-medium-gray);
}

.title{
  color:var(--neutral-charcoal);
}

.teaser-card.large{
  gap:2rem;
}

.teaser-card.large .image{
    border-bottom-right-radius:64px;
  }

.teaser-card.large .content{
    gap:1rem;
  }
`;